import React from 'react';
import { GlobalStyles } from '@mui/material';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { sliceKey, reducer } from 'app/NewAIAvatarLayout/redux/headerSlice/slice';
import { headerSaga } from 'app/NewAIAvatarLayout/redux/headerSlice/saga';
import AppProvider from 'app/NewAIAvatarLayout/globalContexts';
import { Layout } from 'app/NewAIAvatarLayout/features/layout/Layout';

/**
 * NewAIAvatarLayout chrome (providers + sidebar) without the /ai-avatar-layout Switch.
 * Used for shared routes like /autopilot that must keep the same URL in both themes.
 */
export const AIAvatarPageShell: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useInjectReducer({ key: sliceKey, reducer });
  useInjectSaga({ key: sliceKey, saga: headerSaga });

  return (
    <>
      <GlobalStyles
        styles={(theme) => ({
          '*': {
            '&::-webkit-scrollbar': {
              width: '8px',
              height: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.grey[800]
                  : theme.palette.grey[200],
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.grey[600]
                  : theme.palette.grey[400],
              borderRadius: '4px',
              '&:hover': {
                backgroundColor:
                  theme.palette.mode === 'dark'
                    ? theme.palette.grey[500]
                    : theme.palette.grey[500],
              },
            },
            '&::-webkit-scrollbar-corner': {
              backgroundColor:
                theme.palette.mode === 'dark'
                  ? theme.palette.grey[800]
                  : theme.palette.grey[200],
            },
          },
        })}
      />
      <AppProvider>
        <Layout>{children}</Layout>
      </AppProvider>
    </>
  );
};

export default AIAvatarPageShell;
